var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4993 18.3332C15.1017 18.3332 18.8327 14.6022 18.8327 9.99984C18.8327 5.39746 15.1017 1.6665 10.4993 1.6665C5.89698 1.6665 2.16602 5.39746 2.16602 9.99984C2.16602 14.6022 5.89698 18.3332 10.4993 18.3332Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41602 7.9165L11.3326 10.8328M13.8327 6.6665L9.66602 10.8332",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.89eab24d780b55832fe73aee87dbee77.svg";
export { ForwardRef as ReactComponent };